<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-danger">
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
          <b-card no-body>
            <b-card-header class="border-0">
              <b-row align-v="center" slot="header">
                <b-col cols="4"> </b-col>
                <b-col cols="8" class="text-right">
                  <router-link to="agencias/novo" class="btn btn-primary">
                    Novo
                  </router-link>

                  <base-button
                    type="success"
                    @click="
                      exportExcel('publicitario', setLoadingExcel, 'agencia')
                    "
                    :loading="loadingExcel"
                  >
                    Exportar Excel
                  </base-button>
                </b-col>
              </b-row>
            </b-card-header>

            <el-table
              class="table-responsive table"
              header-row-class-name="thead-light"
              :data="data"
              v-loading="loading"
              empty-text="Não há dados para mostrar"
            >
              <el-table-column label="ID" prop="id" min-width="50px">
              </el-table-column>
              <el-table-column
                label="Nome Fantasia"
                prop="nomeFantasia"
                min-width="140px"
              >
              </el-table-column>
              <el-table-column
                label="Nome do Responsável"
                prop="nomeResponsavel"
                min-width="140px"
              >
              </el-table-column>

              <el-table-column
                label="E-mail do Responsável"
                prop="emailResponsavel"
                min-width="140px"
              >
              </el-table-column>

              <el-table-column
                label="Celular do Responsável"
                prop="celularResponsavel"
                min-width="140px"
              >
              </el-table-column>

              <el-table-column
                label="E-mail de Acesso"
                prop="emailAcesso"
                min-width="140px"
              >
              </el-table-column>

              <el-table-column label="Ações" prop="id" min-width="190px">
                <template v-slot="{ row }">
                  <div class="d-flex align-items-center">
                    <base-button
                      size="sm"
                      type="danger"
                      @click="openDeleteModal(row.id)"
                    >
                      Excluir
                    </base-button>
                    <router-link
                      :to="'agencias/' + row.id"
                      class="btn btn-sm btn-primary"
                    >
                      Editar
                    </router-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
              <base-pagination
                v-model="pagination.page"
                :per-page="pagination.size"
                :total="pagination.totalElements"
                v-on:change="load"
              ></base-pagination>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
      <div class="mt-5"></div>
    </b-container>
  </div>
</template>
<script>
import api from "@/services/api";
import { Table, TableColumn } from "element-ui";
import { exportExcel } from "@/services/utils";

export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  data() {
    return {
      data: [],
      loading: false,
      loadingExcel: false,
      pagination: {
        page: 0,
        size: 10,
        totalElements: 0,
        totalPages: 0,
      },
    };
  },
  methods: {
    exportExcel,
    setLoadingExcel(loading) {
      this.loadingExcel = loading;
    },
    async load(page = 1) {
      this.loading = true;
      try {
        const response = await api.get(
          `/publicitario?size=10&page=${page - 1}`
        );
        this.data = response.data.data;
        this.pagination = response.data.pagination;
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    openDeleteModal(id) {
      this.$swal
        .fire({
          title: "Tem certeza que deseja excluir?",
          text: "Isso não poderá ser revertido",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim, excluir!",
          cancelButtonText: "Cancelar",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteData(id);
          }
        });
    },
    async deleteData(id) {
      try {
        await api.delete(`/publicitario/${id}`);
        this.$swal.fire(
          "Excluído!",
          "Os dados foram excluídos com sucesso.",
          "success"
        );

        this.load();
      } catch (err) {
        console.error(err);
        this.$swal(
          "Oops!",
          "Ocorreu um problema ao excluir os dados. Por favor, tente novamente mais tarde."
        );
      }
    },
  },
  async mounted() {
    this.load();
  },
};
</script>
